import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = {
  agencyId?: number;
};

type Options = {
  enabled?: boolean;
};

export const useManagedUserOrgRoles = (params?: Params, options?: Options) => {
  return useQuery({
    queryKey: ["managedUserOrgRoles", params?.agencyId ?? null],
    queryFn: async () =>
      await apiClient.getManagedUserOrgRoles({
        queries: {
          agency_id: params?.agencyId ? String(params.agencyId) : undefined,
        },
      }),
    enabled: options?.enabled ?? true,
  });
};
